import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { traceUFOInteractionOnFirstInteraction } from './pm-plugins/traceUFOInteractionOnFirstInteraction';
export var ufoPlugin = function ufoPlugin() {
  return {
    name: 'ufo',
    pmPlugins: function pmPlugins() {
      var _process;
      var isSSR = Boolean((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
      if (isSSR) {
        // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
        return [];
      }
      if (expValEquals('cc_editor_interactions_trigger_traceufointeraction', 'cohort', 'control')) {
        return [];
      }
      return [{
        name: 'traceUFOInteractionOnFirstInteraction',
        plugin: traceUFOInteractionOnFirstInteraction
      }];
    }
  };
};